<script setup lang="ts">
import type { UncommonsFinding } from '@/api';
import GaiaExtractionCard from '@/components/design/review/GaiaExtractionCard.vue';
import GaiaFieldRow from '@/components/design/base/GaiaFieldRow.vue';
import GaiaQuote from '@/components/design/base/GaiaQuote.vue';
import GaiaText from '@/components/design/base/GaiaText.vue';

const props = defineProps<{
  finding: UncommonsFinding;
}>();

const emit = defineEmits<{
  highlight: [payload: { page: number; texts: string[] }];
}>();

function highlightFinding(): void {
  if (!props.finding.text) return;
  emit('highlight', { page: props.finding.page_number ?? 1, texts: [props.finding.text] });
}
</script>

<template>
  <gaia-extraction-card title="Finding" subtitle="Information from document">
    <gaia-field-row v-if="finding.text" label="Passage" :label-width="86" :divider="false">
      <gaia-quote tone="alert" interactive title="Show in document" @click="highlightFinding">
        {{ finding.text }}
      </gaia-quote>
    </gaia-field-row>

    <gaia-field-row v-if="finding.reason" label="Reason" :label-width="86" :divider="false">
      <gaia-text :style="{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }">
        {{ finding.reason }}
      </gaia-text>
    </gaia-field-row>

    <gaia-text v-if="!finding.text && !finding.reason" size="body" tone="subtle">
      No detail for this finding.
    </gaia-text>
  </gaia-extraction-card>
</template>
